import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import "./MenuBar.css";
import { useAuth } from "../AuthContext";

const MenuBar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { isLoggedIn, userType, mobile } = useAuth();

  return (
    <div className="menu-bar">
      <div className="logo">
        <NavLink to="/" exact>
          PharmaFlow
        </NavLink>
        <span className="subtitle">A Trumac Healthcare Initiative</span>
      </div>
      <div className="menu-icon" onClick={() => setIsOpen(!isOpen)}>
        <i>{isOpen ? "X" : "☰"}</i>
      </div>
      <nav className={isOpen ? "nav-links active" : "nav-links"}>
        <NavLink
          to="/"
          exact
          className={({ isActive }) => (isActive ? "active-link" : "")}
          onClick={() => setIsOpen(false)}
        >
          Products
        </NavLink>
        <NavLink
          to="/gifts"
          className={({ isActive }) => (isActive ? "active-link" : "")}
          onClick={() => setIsOpen(false)}
        >
          Gifts
        </NavLink>{" "}
        <NavLink
          to="/reminder-cards"
          className={({ isActive }) => (isActive ? "active-link" : "")}
          onClick={() => setIsOpen(false)}
        >
          Reminder Cards
        </NavLink>
        <NavLink
          to="/image-reminder-cards"
          className={({ isActive }) => (isActive ? "active-link" : "")}
          onClick={() => setIsOpen(false)}
        >
          Image Reminder Cards
        </NavLink>
        {/* Add NavLink for Gifts */}
        {isLoggedIn && userType === "customer" ? (
          <>
            <NavLink
              to="/customer-schemes"
              className={({ isActive }) => (isActive ? "active-link" : "")}
              onClick={() => setIsOpen(false)}
            >
              Schemes
            </NavLink>
            <NavLink
              to="/customer-dashboard"
              className={({ isActive }) => (isActive ? "active-link" : "")}
              onClick={() => setIsOpen(false)}
            >
              Dashboard
            </NavLink>
            <NavLink
              to="/customer-order-status"
              className={({ isActive }) => (isActive ? "active-link" : "")}
              onClick={() => setIsOpen(false)}
            >
              Order Status
            </NavLink>
            <NavLink
              to="/customer-dispatch-status"
              className={({ isActive }) => (isActive ? "active-link" : "")}
              onClick={() => setIsOpen(false)}
            >
              Dispatches
            </NavLink>
            <NavLink
              to="/orders"
              className={({ isActive }) => (isActive ? "active-link" : "")}
              onClick={() => setIsOpen(false)}
            >
              Past Orders
            </NavLink>

            <NavLink
              to="/invoices"
              className={({ isActive }) => (isActive ? "active-link" : "")}
              onClick={() => setIsOpen(false)}
            >
              Invoices
            </NavLink>

            <NavLink
              to="/complaint-form"
              className={({ isActive }) => (isActive ? "active-link" : "")}
              onClick={() => setIsOpen(false)}
            >
              Complaint
            </NavLink>

            <NavLink
              to="/logout"
              className={({ isActive }) => (isActive ? "active-link" : "")}
              onClick={() => setIsOpen(false)}
            >
              Logout
            </NavLink>
          </>
        ) : isLoggedIn && userType === "employee" ? (
          <>
            <NavLink
              to="/case-sizes"
              className={({ isActive }) => (isActive ? "active-link" : "")}
              onClick={() => setIsOpen(false)}
            >
              Case_Size
            </NavLink>
            <NavLink
              to="/employee-dashboard"
              className={({ isActive }) => (isActive ? "active-link" : "")}
              onClick={() => setIsOpen(false)}
            >
              Dashboard
            </NavLink>
            <NavLink
              to="/order-gifts"
              className={({ isActive }) => (isActive ? "active-link" : "")}
              onClick={() => setIsOpen(false)}
            >
              Order_Gifts
            </NavLink>
            <NavLink
              to="/reports"
              className={({ isActive }) => (isActive ? "active-link" : "")}
              onClick={() => setIsOpen(false)}
            >
              Reports
            </NavLink>
            <NavLink
              to="/area-search"
              className={({ isActive }) => (isActive ? "active-link" : "")}
              onClick={() => setIsOpen(false)}
            >
              Area_Search
            </NavLink>
            <NavLink
              to="/gift-entries"
              className={({ isActive }) => (isActive ? "active-link" : "")}
              onClick={() => setIsOpen(false)}
            >
              Gift_Entries
            </NavLink>
            <NavLink
              to="/qms"
              className={({ isActive }) => (isActive ? "active-link" : "")}
              onClick={() => setIsOpen(false)}
            >
              Queries
            </NavLink>
            <NavLink
              to="/order-entries"
              className={({ isActive }) => (isActive ? "active-link" : "")}
              onClick={() => setIsOpen(false)}
            >
              Orders
            </NavLink>
            {mobile === "1111111111" && (
              <NavLink
                to="/print-label-page"
                className={({ isActive }) => (isActive ? "active-link" : "")}
                onClick={() => setIsOpen(false)}
              >
                Packing_Slip
              </NavLink>
            )}
            <NavLink
              to="/Dispatch"
              className={({ isActive }) => (isActive ? "active-link" : "")}
              onClick={() => setIsOpen(false)}
            >
              Dispatch
            </NavLink>

            {/* Add other employee-specific links here */}
            <NavLink
              to="/logout"
              className={({ isActive }) => (isActive ? "active-link" : "")}
              onClick={() => setIsOpen(false)}
            >
              Logout
            </NavLink>
          </>
        ) : (
          <>
            <NavLink
              to="/login"
              className={({ isActive }) => (isActive ? "active-link" : "")}
              onClick={() => setIsOpen(false)}
            >
              Customer Login
            </NavLink>
            {/* <NavLink
              to="/complaint-form"
              className={({ isActive }) => (isActive ? "active-link" : "")}
              onClick={() => setIsOpen(false)}
            >
              Submit Complaint
            </NavLink> */}
            <NavLink
              to="/employee-login"
              className={({ isActive }) => (isActive ? "active-link" : "")}
              onClick={() => setIsOpen(false)}
            >
              Employee Login
            </NavLink>
            <NavLink
              to="/contact-us"
              className={({ isActive }) => (isActive ? "active-link" : "")}
              onClick={() => setIsOpen(false)}
            >
              Contact Us
            </NavLink>
          </>
        )}
      </nav>
    </div>
  );
};

export default MenuBar;
